import { render, staticRenderFns } from "./ParcelGallery.vue?vue&type=template&id=8cba7f5c&"
import script from "./ParcelGallery.vue?vue&type=script&lang=js&"
export * from "./ParcelGallery.vue?vue&type=script&lang=js&"
import style0 from "./ParcelGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports